import React, { useEffect, useState } from 'react';
import { Input, Tag, Form } from 'antd';

const TagsInput = ({ onChange,initialTags }) => {
  const [inputValue, setInputValue] = useState('');
  const [tags, setTags] = useState([]);
  // Initialize tags with initialTags prop if provided
  useEffect(() => {
    if (initialTags) {
      setTags(initialTags);
    }
  }, [initialTags]);
  // Add tag when enter or comma is pressed
  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault(); // Prevent the default behavior of Enter key (form submit)

      const newTag = inputValue.trim();

      // Check if the input value is not empty and not a duplicate
      if (newTag && !tags.includes(newTag)) {
        const updatedTags = [...tags, newTag];
        setTags(updatedTags);
        onChange(updatedTags); // Update parent form with new tags
      }

      setInputValue(''); // Clear the input
    }
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleRemoveTag = (removedTag) => {
    const updatedTags = tags.filter(tag => tag !== removedTag);
    setTags(updatedTags);
    onChange(updatedTags); // Update parent form with new tags after removal
  };

  return (
    <>
      <Input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
        placeholder="Type and press Enter or ',' to add tags"
      />

      <div style={{ marginTop: '16px' }}>
        {tags.map((tag, index) => (
          <Tag
            key={index}
            closable
            onClose={() => handleRemoveTag(tag)}
            style={{ marginBottom: '4px' }}
          >
            {tag}
          </Tag>
        ))}
      </div>
    </>
  );
};

export default TagsInput;
